import { SelectOptionElement } from '@odin-labs/components';
import { ReprintTempBadgeInput } from 'apollo/generated/client-operations';
import { FormInputTypes, GridColSpan, TypedFormInputs } from 'components/form';
import { PrintIcon } from 'components/icons';
import { ReprintTempBadgeFormData } from 'containers/jobsite/tabs/jobsiteTempBadges/modals/tempBadgeModal/components/printingTempBadgeModalContent/types';
import { TempBadgingStep } from 'containers/jobsite/tabs/jobsiteTempBadges/modals/tempBadgeModal/types';
import { JobsitePrinterOption } from 'containers/utils';

export const getFormInputs = ({
  jobsitePrinterOptions,
  badgingStep,
}: {
  jobsitePrinterOptions: SelectOptionElement[];
  badgingStep: TempBadgingStep;
}): TypedFormInputs<ReprintTempBadgeFormData> => {
  return {
    jobsitePrinter: {
      element: FormInputTypes.Select,
      label: 'Printer',
      layout: [GridColSpan.SpanFull, GridColSpan.SmSpan6],
      elementProps: {
        clearToNull: true,
        isClearable: false,
        disabled:
          jobsitePrinterOptions.length === 0 ||
          badgingStep === TempBadgingStep.Printing,
        options: jobsitePrinterOptions,
        icon: PrintIcon,
      },
      validation: { required: true },
    },
  };
};

export const getFormDefaultValues = (
  lastUsedPrinterOption?: JobsitePrinterOption,
  defaultPrinterOption?: JobsitePrinterOption,
): ReprintTempBadgeFormData => {
  return {
    jobsitePrinter: lastUsedPrinterOption ?? defaultPrinterOption,
  };
};

export const getInput = async (
  tempBadgeId: string,
  data: ReprintTempBadgeFormData,
): Promise<ReprintTempBadgeInput> => {
  return {
    id: tempBadgeId,
    jobsitePrinterId: data.jobsitePrinter.value,
  };
};
